export const isIE11 = /x64|x32/gi.test(window.navigator.userAgent)
